import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import lcversion from "./data/version.txt";

// Function to mask player key
function maskPlayerKey(key) {
    if (!key) return "";
    const halfLength = Math.floor(key.length / 3);
    return key.substring(0, halfLength) + "*".repeat(key.length - halfLength);
}

function Header() {
    const { t } = useTranslation();
    const [version, setVersion] = useState("");
    const playerKey = sessionStorage.getItem("playerKey");

    useEffect(() => {
        const fetchVersion = async () => {
            try {
                const res = await fetch("https://raw.githubusercontent.com/arimetson/hotarusr-web-data/refs/heads/main/data/version.txt");
                if (!res.ok) throw new Error("Network response not ok");
                const text = await res.text();
                setVersion(text.trim());
            } catch (error) {
                console.error("Error fetching remote version, fallback to local:", error);
                fetch(lcversion)
                    .then((res) => res.text())
                    .then((text) => setVersion(text.trim()))
                    .catch((err) => console.error("Error loading local version:", err));
            }
        };

        fetchVersion();
    }, []);

    return (
        <div className="mb-6 p-4 glass-panel rounded-lg flex justify-between items-center text-sm sticky top-0 z-30">
            <div className="font-mono">
                <span className="text-gray-400">Remote Key: </span>
                <span className="text-stardust-gold font-bold tracking-wider">
                    {playerKey ? maskPlayerKey(playerKey) : "NULL"}
                </span>
            </div>
            <div className="text-gray-500">
                {t("versionText")}: <span className="text-gray-300">{version}</span>
            </div>
        </div>
    );
}

export default Header;
